import {ProductBarcode} from "./productBarcode";
import {Company} from "../company";
import {User} from "../user";
import {OrderAddress} from "./orderAddress";

export class Order {

    id?: string;
    number?: number;
    totalPrice?: number;
    shippingPrice?: number;
    shippingType?: string;
    paymentMethod?: string;
    transactionId?: string;
    userId?: string;
    companyId?: string;
    addressId?: string;
    status?: string;
    user?: User;
    company?: Company;
    address?: OrderAddress;
    barcodes?: ProductBarcode[];
    orderBarcodes?: any[];
    createdAt?: string;
    fiscalCode?: string;

    constructor(raw?: any) {
        if (raw) {
            if (raw.id || raw.id !== '') this.id = raw.id
            this.number = parseFloat(raw.number);
            this.totalPrice = parseFloat(raw.totalPrice);
            this.shippingPrice = parseFloat(raw.shippingPrice);
            this.shippingType = raw.shippingType;
            this.paymentMethod = raw.paymentMethod;
            this.transactionId = raw.transactionId;
            this.userId = raw.userId;
            this.companyId = raw.companyId;
            this.addressId = raw.addressId;
            this.status = raw.status;
            this.user = raw.user;
            this.company = raw.company;
            this.address = raw.address;
            this.createdAt = raw.createdAt;
            if (raw.barcodes && raw.barcodes.length > 0) this.barcodes = raw.barcodes;
            if (raw.orderBarcodes && raw.orderBarcodes.length > 0) this.orderBarcodes = raw.orderBarcodes;
            this.fiscalCode = raw.fiscalCode;
        }
    }
}
